// extracted by mini-css-extract-plugin
export default {"displayDataContainer":"TileContainer_displayDataContainer__6rtXZ"};